(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('FileContentController', FileContentController);

    FileContentController.$inject = ['DataUtils', 'FileContent', 'FileContentSearch'];

    function FileContentController(DataUtils, FileContent, FileContentSearch) {

        var vm = this;

        vm.fileContents = [];
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            FileContent.query(function(result) {
                vm.fileContents = result;
                vm.searchQuery = null;
            });
        }

        function search() {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            FileContentSearch.query({query: vm.searchQuery}, function(result) {
                vm.fileContents = result;
                vm.currentSearch = vm.searchQuery;
            });
        }

        function clear() {
            vm.searchQuery = null;
            loadAll();
        }    }
})();
